import { Navigate, useParams } from 'react-router-dom';

import { useGetPorcentajeIvaBienes} from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SavePorcentajeIvaRetBienes } from '../../shared/components/savePorcentajeRetIvaBienees';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateIvaPageInterface {}

const UpdateBienesIvaRetPage: React.FC<UpdateIvaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_porcentajeretivabienes);

  const { id } = useParams();
  const { data, isLoading } = useGetPorcentajeIvaBienes(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_porcentaje_ret_iva_bienes) return <Navigate to="/parametrizacion/porcentajes-ret-iva-bienes" />;

  return <SavePorcentajeIvaRetBienes titlePage="Editar Porcentaje Retencion IVA" editPorcentajeIvaBienes={data.data} />;
};

export default UpdateBienesIvaRetPage;
